/* GENERATED by design-system/pdp/events.mjs via pdp/build-theme.mjs. Do not edit.
   The store's own analytics events, published through Shopify.analytics.publish (documented:
   https://shopify.dev/docs/api/web-pixels-api/emitting-data). First-party: no tracker, no request, no cookie.
   Tests: design-system/pdp/test/events.test.mjs and events-browser.test.mjs. */
(function () {
  if (window.__rossumEventsInstalled) return;
  window.__rossumEventsInstalled = true;

  var ALLOWED = {"rossum:faq_open":["page_type","product_handle","question_id"],"rossum:file_download":["page_type","product_handle","file_name","kind"],"rossum:release_notes_open":["page_type","product"],"rossum:video_play":["page_type","product_handle","video_id"],"rossum:dealer_click":["dealer_host","region"],"rossum:newsletter_signup":[],"rossum:outbound_click":["host"]};
  var LOADER = document.currentScript;
  var PAGE_TYPE = "";
  try { PAGE_TYPE = (LOADER && LOADER.getAttribute("data-page-type")) || ""; } catch (e) {}
  var NEWSLETTER_KEY = "rossum:ev:newsletter";

  function cleanValue(v) {
    var s;
    try { s = v == null ? "" : String(v); } catch (e) { return ""; }
    s = s.replace(/[\u0000-\u001f\u007f]+/g, " ").replace(/^\s+|\s+$/g, "");
    if (/[^\s@]+@[^\s@]+/.test(s)) return "";
    return s.length > 120 ? s.slice(0, 120) : s;
  }

  function fileNameOf(href, base) {
    var h = href == null ? "" : String(href);
    if (h === "") return "";
    if (h.charAt(0) === "#") return h.slice(0, 120);
    var u;
    try { u = new URL(h, base); } catch (e) { return ""; }
    if (u.protocol !== "http:" && u.protocol !== "https:") return "";
    var parts = u.pathname.split("/");
    var last = "";
    for (var i = parts.length - 1; i >= 0; i--) { if (parts[i]) { last = parts[i]; break; } }
    try { last = decodeURIComponent(last); } catch (e) {}
    return last.slice(0, 120);
  }

  function hostOf(href, base) {
    var u;
    try { u = new URL(String(href == null ? "" : href), base); } catch (e) { return ""; }
    if (u.protocol !== "http:" && u.protocol !== "https:") return "";
    return u.hostname.toLowerCase();
  }

  function isOwnHost(host, ownHost) {
    if (!host) return false;
    var own = [String(ownHost || ""), "rossum-electro.com", "myshopify.com", "shopify.com", "shopifycdn.com", "shopifycdn.net", "shop.app"];
    for (var i = 0; i < own.length; i++) {
      if (!own[i]) continue;
      if (host === own[i] || host.slice(-(own[i].length + 1)) === "." + own[i]) return true;
    }
    return false;
  }

  function handleOfPath(path) {
    var m = /\/products\/([^\/?#]+)/.exec(String(path || ""));
    if (!m) return "";
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function pageTypeFromPath(path) {
    var p = String(path || "/").replace(/^\/[a-z]{2}(-[a-z0-9]{2,})?(?=\/)/i, "");
    if (p === "" || p === "/") return "index";
    if (/^\/(?:collections\/[^\/]+\/)?products\/[^\/]/.test(p)) return "product";
    if (/^\/collections(\/|$)/.test(p)) return "collection";
    if (/^\/pages\/[^\/]/.test(p)) return "page";
    if (/^\/blogs\/[^\/]+\/[^\/]/.test(p)) return "article";
    if (/^\/blogs\/[^\/]/.test(p)) return "blog";
    if (/^\/cart(\/|$)/.test(p)) return "cart";
    if (/^\/search(\/|$)/.test(p)) return "search";
    return "";
  }

  function pickPayloadWith(allowed, name, data) {
    var out = {};
    var keys = Object.prototype.hasOwnProperty.call(allowed, name) ? allowed[name] : [];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      out[k] = cleanValue(data && Object.prototype.hasOwnProperty.call(data, k) ? data[k] : "");
    }
    return out;
  }

  function pageType() {
    if (PAGE_TYPE) return PAGE_TYPE;
    try { var m = window.ShopifyAnalytics.meta.page.pageType; if (m) return String(m); } catch (e) {}
    return pageTypeFromPath(location.pathname);
  }

  // Publish, and keep the last 50 events on the page for tests. Safe when Shopify's object is missing
  // (a local mock page, a blocker) or throws, or when publish returns a promise that rejects.
  function emit(name, data) {
    var d = pickPayloadWith(ALLOWED, name, data);
    var rec = window.__rossumEvents;
    if (!rec || typeof rec.push !== "function") rec = window.__rossumEvents = [];
    rec.push({ name: name, data: d });
    if (rec.length > 50) rec.splice(0, rec.length - 50);
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        var r = Shopify.analytics.publish(name, d);
        if (r && typeof r.catch === "function") r.catch(function () {});
      }
    } catch (e) {}
  }

  // A download-page section is id="dl-<handle>"; any other id is the section's own name.
  function sectionName(el) {
    var s = el.closest && el.closest("section[id]");
    var id = s ? s.id : "";
    return id.indexOf("dl-") === 0 ? id.slice(3) : id;
  }

  // What a link in a file list is. Release-note bodies and the page's text notes hold ordinary links.
  function fileKind(a, href) {
    if (a.closest(".dl-body, .dl-note")) return "";
    if (a.closest(".docnote")) return "doc_link";
    if (a.closest(".dl-list-docs")) return "documentation";
    if (a.closest(".dl-list")) {
      var host = hostOf(href, document.baseURI);
      if (a.hasAttribute("download") || /\.[a-z0-9]{2,5}$/i.test(fileNameOf(href, document.baseURI)) || (host && !isOwnHost(host, location.hostname))) return "download";
    }
    return "";
  }

  function onClick(t) {
    if (!t || !t.closest) return;
    var handle = handleOfPath(location.pathname);
    var facade = t.closest(".vfacade[data-yt]");
    if (facade) {
      emit("rossum:video_play", { page_type: pageType(), product_handle: handle, video_id: facade.getAttribute("data-yt") });
      return;
    }
    var a = t.closest("a[href]");
    if (!a) return;
    var href = a.getAttribute("href");
    if (!href) return;
    var dealer = a.closest("[data-dealer]");
    if (dealer) {
      emit("rossum:dealer_click", { dealer_host: hostOf(href, document.baseURI), region: dealer.getAttribute("data-country") });
      return;
    }
    var kind = fileKind(a, href);
    if (kind) {
      emit("rossum:file_download", { page_type: pageType(), product_handle: handle || sectionName(a), file_name: fileNameOf(href, document.baseURI), kind: kind });
      return;
    }
    var host = hostOf(href, document.baseURI);
    if (host && !isOwnHost(host, location.hostname)) emit("rossum:outbound_click", { host: host });
  }

  function onToggle(d) {
    if (!d || d.tagName !== "DETAILS" || !d.open) return;
    if (d.classList.contains("dl-notes")) {
      emit("rossum:release_notes_open", { page_type: pageType(), product: sectionName(d) || handleOfPath(location.pathname) });
      return;
    }
    var p = d.parentElement;
    if (p && p.classList.contains("faq-item")) {
      emit("rossum:faq_open", { page_type: pageType(), product_handle: handleOfPath(location.pathname), question_id: d.id });
    }
  }

  // The newsletter form posts and the page reloads with the success message in place of the form.
  // Publish once for that arrival: not for a reload or a history step (the message is still there), and
  // not twice for the same URL in one session. A visitor who signs up twice in a session from the same
  // URL is counted once; the address is never read.
  function onNewsletter() {
    if (!document.querySelector(".rfooter-nl-ok")) return;
    try {
      var nav = performance.getEntriesByType("navigation")[0];
      if (nav && (nav.type === "reload" || nav.type === "back_forward")) return;
    } catch (e) {}
    var here = String(location.href).split("#")[0];
    try {
      if (window.sessionStorage.getItem(NEWSLETTER_KEY) === here) return;
      window.sessionStorage.setItem(NEWSLETTER_KEY, here);
    } catch (e) {}
    emit("rossum:newsletter_signup", {});
  }

  document.addEventListener("click", function (e) {
    try { onClick(e.target); } catch (err) {}
  }, true);
  document.addEventListener("toggle", function (e) {
    try { onToggle(e.target); } catch (err) {}
  }, true);
  // The loader is deferred, so the footer is already parsed here.
  try { onNewsletter(); } catch (e) {}
})();
